import { getRoleByUser } from './roles-users.service';
import { getPoliciesByRole } from './roles-policies.service';

export let policies = [];

export const getSummarize = async (userId) => {
  try {
    const role = await getRoleByUser(userId);
    const policiesInRole = await getPoliciesByRole(role.id);
    policies = policiesInRole.map(policy => policy.actions).flat();
    return policiesInRole;
  } catch (err) {
    return err;
  }
}

export const has = (action) => {
  return policies ? policies.some(act => act === action) : false;
}

export const cleanPolicies = () => {
  policies = undefined;
}